import { jwtDecode } from "jwt-decode";

export const isAuthenticatedPat = () => {
  // Check if the user is authenticated based on your logic
  // For example, you might check if a token exists in local storage
  /* const currentDate = new Date();
  const tokentem = localStorage.getItem("pat-token");
  if (tokentem) {
    const token = new Date(tokentem);
    return !!token.getTime() <= currentDate.getTime(); // Return true if the token exists, otherwise false
  } else {
    return false;
  } */
  const tokenStatus = isTokenExpired();
  console.log(tokenStatus, "tokenStatus");
  return !tokenStatus;
};

export const getToken = () => {
  const token = localStorage.getItem("pat-token");
  return token;
};

export const getTokenClinicDoctor = () => {
  const token = localStorage.getItem("pat-clinic-doctor");
  let data = {
    doctorId: null,
    clinicId: null,
    doctorName: "",
  };
  if (token) {
    data = JSON.parse(token);
  }
  return data;
};

export const isTokenExpired = () => {
  const token = getToken();
  if (token) {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    
    return decodedToken.exp < currentTime;
  }
  return true;
};

export const getValueFromPatToken = (key) => {
  const token = getToken();

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken && decodedToken.hasOwnProperty(key)) {
        return decodedToken[key];
      } else {
        console.error("Token does not contain the specified key:", key);
        return null;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  } else {
    console.error("Token not found in localStorage");
    return null;
  }
};

export const convertToNumber = (input)=>{
return typeof input =='string' ? Number(input): input;
}
